import React, { Component } from "react";
import s from "../Calendar.css";
import cx from "classnames";
import { FormattedMessage } from "react-intl";
import messages from "../../../locale/messages";

class CalendarLegends extends Component {
  render() {
    return (
      <div className={s.lableWeight}>
        <p className={cx(s.bookedWidth)}>
          <span className={cx(s.notAvailableColor, "availableRTl")}></span>
          <FormattedMessage {...messages.booked} />
        </p>
        <p className={s.calenderColorText}>
          <span className={cx(s.bookedColor, "availableRTl")}></span>
          <FormattedMessage {...messages.notAvailable} />
        </p>
        <p className={s.calenderColorText}>
          <span className={cx(s.availableColor, "availableRTl")}></span>
          <FormattedMessage {...messages.availableLabel} />
        </p>
        <p className={s.calenderColorText}>
          <span className={cx(s.specialColor, "availableRTl")}></span>
          <FormattedMessage {...messages.sessionPrice} />
        </p>
      </div>
    );
  }
}

export default CalendarLegends;
